import { useCallback } from "react";
import { layerClassified } from "../../../resources/classify";
import { useClassificationReset } from "../../Classification/hooks/useClassificationReset";

export const useRemoveClassification = <Value>(onChange: (v?: Value) => void, value?: Value): VoidFunction => {
  const resetClassification = useClassificationReset();

  return useCallback(() => {
    onChange(value);
    resetClassification();

    layerClassified.invalidateAll();
  }, [value, onChange, resetClassification]);
};
